export default "__VITE_ASSET__BJOWP9iv__"